import * as React from 'react';
export const gopaySvg = React.forwardRef(function gopaySvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M0 0h16v16H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M15.988 7.598a2.918 2.918 0 0 0-1.043-2.053 3.328 3.328 0 0 0-2.283-.774H4.001a.608.608 0 0 1-.405-.158.507.507 0 0 1-.167-.38c0-.298.256-.54.572-.54h8.776a2.469 2.469 0 0 0-.587-1.491 2.76 2.76 0 0 0-1.412-.883 23.574 23.574 0 0 0-7.732 0 3.716 3.716 0 0 0-1.843 1.043 3.336 3.336 0 0 0-.899 1.833 24.201 24.201 0 0 0 0 7.65 3.554 3.554 0 0 0 1.085 1.893 3.97 3.97 0 0 0 2.04.983c3.174.372 6.385.372 9.56 0a3.421 3.421 0 0 0 1.793-.956 3.06 3.06 0 0 0 .858-1.757c.281-1.455.4-2.932.348-4.41Zm-2.845 1.81v.478a.508.508 0 0 1-.167.38.577.577 0 0 1-.405.159.61.61 0 0 1-.405-.159.535.535 0 0 1-.166-.38v-.479a.797.797 0 0 1-.264-.41.757.757 0 0 1 .032-.477.815.815 0 0 1 .315-.377.901.901 0 0 1 .488-.142.91.91 0 0 1 .489.142.815.815 0 0 1 .315.377.756.756 0 0 1 .032.477.797.797 0 0 1-.264.41Z',
    }),
  );
});
gopaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var gopay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'gopay',
  svg: gopaySvg,
};
